import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c4a57c34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "admin-header" }
const _hoisted_2 = { class: "back-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Administrator Kontrolcenter", -1))
const _hoisted_4 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_user_table = _resolveComponent("user-table")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_trip_table = _resolveComponent("trip-table")!
  const _component_image_table = _resolveComponent("image-table")!
  const _component_AdminUtilities = _resolveComponent("AdminUtilities")!
  const _component_EditHomepageForm = _resolveComponent("EditHomepageForm")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_card = _resolveComponent("b-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_button, {
          size: "lg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Tilbage ")
          ]),
          _: 1
        })
      ]),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_b_card, { "no-body": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_tabs, { card: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_b_tab, { title: "Brugere" }, {
                default: _withCtx(() => [
                  _createVNode(_component_user_table, {
                    users: _ctx.users,
                    "loading-users": _ctx.loadingUsers,
                    "onUpdate:loadingUsers": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loadingUsers) = $event)),
                    onRefresh: _ctx.fetchUsers
                  }, null, 8, ["users", "loading-users", "onRefresh"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Ture" }, {
                default: _withCtx(() => [
                  _createVNode(_component_trip_table, {
                    trips: _ctx.trips,
                    "loading-trips": _ctx.loadingTrips,
                    "onUpdate:loadingTrips": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadingTrips) = $event)),
                    onRefresh: _ctx.fetchTrips
                  }, null, 8, ["trips", "loading-trips", "onRefresh"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Billeder" }, {
                default: _withCtx(() => [
                  _createVNode(_component_image_table, {
                    images: _ctx.images,
                    users: _ctx.users,
                    "loading-images": _ctx.loadingImages,
                    "onUpdate:loadingImages": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.loadingImages) = $event)),
                    onRefresh: _ctx.fetchImages
                  }, null, 8, ["images", "users", "loading-images", "onRefresh"])
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Funktioner" }, {
                default: _withCtx(() => [
                  _createVNode(_component_AdminUtilities)
                ]),
                _: 1
              }),
              _createVNode(_component_b_tab, { title: "Forside" }, {
                default: _withCtx(() => [
                  _createVNode(_component_EditHomepageForm)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}